import React from 'react';
import cn from 'classnames';
import { useTranslation } from 'react-i18next';

import Button from 'components/common/Button';
import ClearFormModal from 'components/PopupForms/ClearFormConfirm/ClearFormModal';

import styles from '../styles.module.scss';

interface SearchFormButtonsProps {
  isAdditionalOpen: boolean;
  onToggleAdditional: () => void;
  onClearForm: () => void;
}

const SearchFormButtons: React.FC<SearchFormButtonsProps> = ({
  isAdditionalOpen,
  onToggleAdditional,
  onClearForm,
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.buttonsContainer}>
      <button
        type="button"
        onClick={onToggleAdditional}
        className={cn(styles.additionalButton, styles.parameterButton)}
      >
        {t('cargoSearch.additional_button')}
        <span
          className={cn(styles.arrowButton, {
            [styles['arrowButton--reverse']]: isAdditionalOpen,
          })}
        />
      </button>
      <div className={styles.buttonsGroup}>
        <ClearFormModal
          buttonClassName={styles.resetButton}
          onConfirm={onClearForm}
        />
        <Button type="submit">{t('cargoSearch.search_button')}</Button>
      </div>
    </div>
  );
};

export default SearchFormButtons;
